import { FC } from 'react'

import { AdverseMediaRiskLevelType } from '~bank-adverse-media/types'

type RiskLevelLabel = AdverseMediaRiskLevelType

type Props = {
  riskLevel: RiskLevelLabel
}

const getRiskLevelStyle = (label: RiskLevelLabel) => {
  switch (label) {
    case 'Unknown':
      return { color: 'var(--theme-colors-theme-negative-darker)', label: 'Unknown' }
    case 'Low':
      return { color: 'var(--theme-colors-theme-brand-lighter)', label: 'Low' }
    case 'Acknowledged Medium':
      return { color: 'var(--theme-colors-theme-negative-darker)', label: 'Acknowledged Medium' }
    case 'Medium':
      return { color: 'var(--theme-colors-theme-negative-darker)', label: 'Medium' }
    case 'Acknowledged High':
      return { color: 'var(--theme-colors-theme-negative-main)', label: 'Acknowledged High' }
    case 'High':
      return { color: 'var(--theme-colors-theme-negative-main)', label: 'High' }
    default:
      throw new Error(`Unsupported risk level: ${label}`)
  }
}

export const RiskLevel: FC<Props> = ({ riskLevel }) => {
  if (!riskLevel) {
    return null
  }

  const { color, label } = getRiskLevelStyle(riskLevel)

  return <b style={{ color }}>{label}</b>
}
